var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContainer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_square_358910",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10134",
    "data-name": "Group 10134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10133",
    "data-name": "Group 10133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10124",
    "data-name": "Group 10124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10122",
    "data-name": "Group 10122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17091",
    "data-name": "Rectangle 17091",
    width: 20.667,
    height: 1,
    transform: "translate(5.667 2.596)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10123",
    "data-name": "Group 10123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17092",
    "data-name": "Rectangle 17092",
    width: 20.667,
    height: 1,
    transform: "translate(5.667 28.812)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10127",
    "data-name": "Group 10127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10125",
    "data-name": "Group 10125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17093",
    "data-name": "Rectangle 17093",
    width: 1,
    height: 20.667,
    transform: "translate(2.393 5.871)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10126",
    "data-name": "Group 10126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17094",
    "data-name": "Rectangle 17094",
    width: 1,
    height: 20.667,
    transform: "translate(28.607 5.871)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10132",
    "data-name": "Group 10132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10128",
    "data-name": "Group 10128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8866",
    "data-name": "Path 8866",
    d: "M31,1V5.194H26.806V1H31m1-1H25.806V6.194H32V0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10129",
    "data-name": "Group 10129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8867",
    "data-name": "Path 8867",
    d: "M5.194,26.806V31H1V26.806H5.194m1-1H0V32H6.194V25.806Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10130",
    "data-name": "Group 10130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8868",
    "data-name": "Path 8868",
    d: "M5.194,1V5.194H1V1H5.194m1-1H0V6.194H6.194V0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10131",
    "data-name": "Group 10131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M31,26.806V31H26.806V26.806H31m1-1H25.806V32H32V25.806Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.e393b162.svg";
export { ForwardRef as ReactComponent };